var ui_templates = require("ui-templates");
var Sidebar = ui_templates.Sidebar;
var SidebarPackageGenerator = require('./sidebar__package__generator.js');

class PackageSidebar extends Sidebar {
    /**
     * Add package generator
     */
    addPackageGenerator(title, width, theme){
        return new SidebarPackageGenerator({
            target: this.$el,
            fields: {
                'title': title,
                'width': width,
                'theme': theme
            }
        });
    }
}

module.exports = PackageSidebar;
